export const MODES = {
  SENSATION: 'mw6_sensation',
  PRODUCT: 'mw6_product',
};
export const SIZES = {
  COMPACT: 'compact',
  WIDE: 'wide', // legacy mode.
};
export const DEFAULT_TRACK_WIDTH = 1300;